module.exports = __webpack_public_path__ + "static/media/profile.049febf8.png";